import React, { useRef } from 'react';
type Props = {
  value: string;
  onChange: (value: string) => void;
  length?: number;
  disabled?: boolean;
};
// A segmented 8-digit code entry, one box per digit.
export function CodeInput({
  value,
  onChange,
  length = 8,
  disabled
}: Props) {
  const refs = useRef<Array<HTMLInputElement | null>>([]);
  const digits = value.split('').concat(Array(length).fill('')).slice(0, length);
  const setDigit = (index: number, char: string) => {
    const clean = char.replace(/\D/g, '').slice(-1);
    const next = digits.slice();
    next[index] = clean;
    onChange(next.join('').slice(0, length));
    if (clean && index < length - 1) {
      refs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      refs.current[index - 1]?.focus();
    }
    if (e.key === 'ArrowLeft' && index > 0) refs.current[index - 1]?.focus();
    if (e.key === 'ArrowRight' && index < length - 1) refs.current[index + 1]?.focus();
  };
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
    onChange(pasted);
    const focusIndex = Math.min(pasted.length, length - 1);
    refs.current[focusIndex]?.focus();
  };
  return <div className="flex justify-between gap-2 sm:gap-3" role="group" aria-label="8-digit SKR code" data-id="element-14" data-mp="29n7l34gmvzkg">
      {digits.map((digit, i) => <input key={i} ref={el => refs.current[i] = el} type="text" inputMode="numeric" maxLength={1} value={digit} disabled={disabled} aria-label={`Digit ${i + 1}`} onChange={e => setDigit(i, e.target.value)} onKeyDown={e => handleKeyDown(i, e)} onPaste={handlePaste} className="h-14 w-full rounded-xl border border-steca-200 bg-white text-center font-display text-xl font-bold text-steca-ink outline-none transition-colors focus:border-steca-500 focus:ring-2 focus:ring-steca-200 disabled:bg-slate-50 sm:h-16 sm:text-2xl" data-id="element-15" data-mp="2jflpk4z3jkab" data-mpi={i} />)}
    </div>;
}